import React, {useEffect, useState} from 'react';
import CreateCampaignsSideMenu, {campaignsTypes} from "./CreateCampaignsSideMenu/CreateCampaignsSideMenu";
import CreateCampaignsContent from "./CreateCampaignsContent/CreateCampaignsContent";
import './CreateCampaignsLayout.css';

const CrateCampaignsLayout = (props) => {
    // svi ovi props nam dolaze iz index.js Dashboard
    const {sendCampaigns, companyData, visits, newCampaignsListUid, companyLogoURL, loading} = props;
    const [campaignType, setCampaignType] = useState('VOLUME');

    useEffect(() => {
        if(newCampaignsListUid.length) {
            setCampaignType(campaignsTypes.custom);
        }
    }, [newCampaignsListUid]);

    const handleSelectedCampaign = (selectedCampaign) => {
        setCampaignType(selectedCampaign);
    };
    const sendCampaignsDataToDashboard = (newCampaignsData) => {
        sendCampaigns(newCampaignsData);
    };
    return (
        <div className='create-campaigns-layout'>
            <CreateCampaignsSideMenu selectCampaign={handleSelectedCampaign}/>
            <CreateCampaignsContent sendCampaigns={sendCampaignsDataToDashboard}
                                    campaignType={campaignType}
                                    companyData={companyData}
                                    newCampaignsListUid={newCampaignsListUid}
                                    visits={visits}
                                    loading={loading}
                                    companyLogoURL={companyLogoURL}/>
        </div>
    );

};

export default CrateCampaignsLayout;
